import { render, staticRenderFns } from "./businessLicense.vue?vue&type=template&id=53ebe862&scoped=true"
import script from "./businessLicense.vue?vue&type=script&lang=js"
export * from "./businessLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ebe862",
  null
  
)

export default component.exports